import React from 'react'

/**
 * Email greeting and introduction section
 * @param {string} boatName - Name of the vessel
 * @param {string} dockLabel - Dock/berth label
 */
export const Header = ({ boatName, dockLabel }) => (
    <p>
        Bonjour, <br />
        <br />
        Voici les informations concernant le départ du navire <b>{boatName}</b> au quai{' '}
        <b>{dockLabel}</b>.<br />
        Here is the information regarding the departure of the <b>{boatName}</b> at berth{' '}
        <b>{dockLabel}</b>.
    </p>
)
